import CourseInBlockPreview from "./CourseInBlockPreview";

export default CourseInBlockPreview;